import { useMemo } from 'react';
import { SELLING_PRODUCT_VALORACION_ROUTE } from '../../utils/routes/const';

import Link from '../Atoms/Link';
import { SearchResult } from '../SellingHero/SearchInput';

type SearchOverlaySuggestionsType = {
  suggestions: SearchResult[],
  isLoading: boolean,
}

const SearchOverlaySuggestions = ({suggestions, isLoading}: SearchOverlaySuggestionsType) => {
  if (isLoading) {
    return <div className="h-full w-full flex flex-col align-center font-roboto text-xl font-light text-primary z-10">Loading...</div>
  }

  if (!suggestions || suggestions.length <= 3) {
    return null;
  }

  if (suggestions && suggestions['hydra:member'].length === 0) {
    return <div className="h-full w-full flex flex-col align-center font-roboto text-xl font-light text-primary z-10">No Search Results</div>
  }

  const results = useMemo(() => suggestions['hydra:member'], [suggestions]);

  return (
    <div className="h-full w-full flex flex-col align-center">
      {results.map((result) => (
          <Link
            key={`SearchOverlaySuggestion-${result.id}`}
            to={SELLING_PRODUCT_VALORACION_ROUTE(result.slug)}
            className="font-roboto text-xl font-light text-primary mb-8 z-10"
          >
            {result.brand} - {result.model} ({result.id}) {result.watchInfo ? `(${result.watchInfo})` : ''}
          </Link>
        )
      )}
    </div>
  )
}

export default SearchOverlaySuggestions
